import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appSelectTextOnFocus]',
  standalone: true
})
export class SelectTextOnFocusDirective {

  constructor(private el: ElementRef) {
    //
  }
  @HostListener('focus')
  onFocus(): void {
    // Wait for a tiny moment (you know, like a magical pause)
    setTimeout(() => {
      this.el.nativeElement.select();
    });
  }
}
